import Vue from 'vue'
import App from './App.vue'
import router from './router'
import HoverZoom from './components/HoverZoom';
import Lightbox from './components/Lightbox';
import NotificationBar from './components/NotificationBar';
import Header from './components/Header';
import Menu from './components/Menu';
import Gallery from './components/Gallery';
import Footer from './components/Footer';
import Parallax from 'vue-parallaxy'
import store from './assets/js/store.js';
import * as firebase from 'firebase';
import { MdButton, MdField, MdCard } from 'vue-material/dist/components'

import './assets/styles/main.scss'
import './assets/styles/nerd-fonts-generated.min.css'

var config = {
  apiKey: "AIzaSyDug-kE7G8aLVtEvjjL6r3KnIakpWRquNQ",
  authDomain: "justin-thouless.firebaseapp.com",
  databaseURL: "https://justin-thouless.firebaseio.com",
  projectId: "justin-thouless",
  storageBucket: "justin-thouless.appspot.com",
  messagingSenderId: "602266293360"
};
firebase.initializeApp(config);

store.commit("setFirebase", firebase)

Vue.config.productionTip = false

Vue.use(MdButton)
Vue.use(MdField)
Vue.use(MdCard)

Vue.component('hover-zoom', HoverZoom);
Vue.component('lightbox', Lightbox);
Vue.component('notificationbar', NotificationBar);
Vue.component('Header', Header);
Vue.component('Parallax', Parallax);
Vue.component('Menu', Menu);
Vue.component('Gallery', Gallery);
Vue.component('Footer', Footer);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
